// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2E5Pf","header":"Messages_header__3tE8k"};